import { render, staticRenderFns } from "./TranslateForm.vue?vue&type=template&id=41066bbd&scoped=true"
import script from "./TranslateForm.vue?vue&type=script&lang=js"
export * from "./TranslateForm.vue?vue&type=script&lang=js"
import style0 from "./TranslateForm.vue?vue&type=style&index=0&id=41066bbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41066bbd",
  null
  
)

export default component.exports